// @file User-facing labels for the wall administrator collaborator role.
import { isAppUsing } from '@@/bits/flip'

function wallAdminRoleLabel(adminCopy: string, creatorCopy: string): string {
  return isAppUsing('renameAdminOwnerToCreator') ? creatorCopy : adminCopy
}

export { wallAdminRoleLabel }
